import { Metadata } from 'next';

export function __MetaTags(data: {
    title?: string;
    description?: string;
    image?: string;
    applicationName?: string;
    keywords?: string | string[];
}) {
    let title = 'آقای شهر';
    let description = 'آقای شهر پلتفرم واسط فروش';
    let image = '/android-chrome-512x512.png';
    let applicationName = 'آقای شهر';
    let keywords: string | string[] = 'آقای شهر';
    if (data.title) title = data.title;
    if (data.description) description = data.description;
    if (data.image) image = data.image;
    if (data.applicationName) applicationName = data.applicationName;
    if (data.keywords) keywords = data.keywords;
    const metadata: Metadata = {
        title,
        description,
        applicationName,
        keywords,
        twitter: {
            title,
            description,
            images: image,
        },
        openGraph: {
            title,
            description,
            images: image,
        },
    };
    return metadata;
}
